.masonryWrapper {
  position: relative;
  width: var(--layout-width);
  margin: 40px auto auto auto;
}

.grid {
  width: 100%;
}

.gridSizer {
  width: var(--masonry-design-card-width, var(--card-size));
}

.gutterSizer {
  width: var(--gutter-size);
}

.item {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
  width: var(--masonry-design-card-width, var(--card-size));
  margin-bottom: var(--gutter-size);
  overflow: visible;
}

.item:hover {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
}

.landscapeGridSizer {
  width: var(--masonry-design-card-width, var(--landscape-card-size));
}

.landscapeGutterSizer {
  width: var(--landscape-gutter-size);
}

.itemLandscape {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
  overflow: visible;
  width: var(--masonry-design-card-width, var(--landscape-card-size));
  margin-bottom: var(--landscape-gutter-size);
}

.item > img {
  width: 100%;
}

.cardBottom {
  height: 72px;
  padding: 0px 12px 0px 12px;
}

.cardBottomRow {
  display: flex;
  align-items: center;
  position: relative;
}

.popout {
  position: absolute;
  width: 300px;
  bottom: 25px;
  z-index: 1;
  border: solid 1px #e4e4e4;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
}

.designTitle {
  color: var(--color-easil-black);
  margin-bottom: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.caretWrapper {
  display: flex;
}

.image {
  border-radius: 2px 2px 0px 0px;
}

.popoutContentTop {
  border-bottom: 1px solid lightgray;
  padding: 16px;
}

.popoutContentTop1Row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 11px;
}

.popoutContentTop1Row > div:first-child {
  padding-right: 10px;
  font-size: 15px;
  color: var(--color-easil-black);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.popoutContentTop1RowEditting {
  align-items: center;
  display: flex;
  margin-bottom: 8px;
}

.popoutContentTop1RowEditting > svg:last-child {
  margin-left: 12px;
}

.editDesignName {
  height: 36px;
  margin-right: 16px;
}

.popoutContentTop > div + div {
  font-size: 13px;
  color: var(--color-easil-gray);
  margin-bottom: 0px;
}

.popoutContentMiddle {
  border-bottom: 1px solid lightgray;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 16px 0px 16px 0px;
}

.popoutContentMiddle > ul > li {
  display: flex;
  align-items: center;
  line-height: 1.71;
  color: var(--color-easil-gray-x-dark);
  margin-bottom: 10px;
  padding: 0px 16px 0px 16px;
  cursor: pointer;
}

.popoutContentMiddle > ul > li:last-child {
  margin-bottom: 0px;
}

.popoutContentMiddle > ul > li:hover {
  background-color: var(--color-hover-color);
}

.popoutContentMiddle > ul > li > div {
  padding-left: 12px;
}

.popoutContentBottom {
  border-bottom: 1px solid lightgray;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 16px;
}

.topRowLeftItem {
  margin-left: 32px;
}

.folderMenu {
  margin-top: 60px;
}

.folderMenuWrapper {
  position: relative;
}

.folderMenuLabelWrapper {
  align-items: center;
  cursor: pointer;
  display: flex;
  user-select: none;
}

.folderMenuLabel {
  color: var(--color-easil-black);
  font-size: 15px;
  margin: 0 12px 0 8px;
}

.folderMenuDropdown {
  background-color: #fff;
  border: 1px solid var(--color-easil-gray-x-light);
  border-radius: 4px;
  left: 0;
  padding: 16px;
  position: absolute;
  top: 40px;
  z-index: 2;
}

.folderMenuDropdownOption {
  color: var(--color-easil-black);
  cursor: pointer;
  user-select: none;
}

.emptyStateContainer {
  display: flex;
  align-items: center;
  min-height: 300px;
  padding-top: 156px;
  flex-direction: column;
  padding-bottom: 206px;
}

.emptyStateIcons {
  margin-bottom: 32px;
}

.emptyStateTitle {
  font-size: 24px;
  margin-bottom: 16px;
  color: var(--color-easil-black);
}

.emptyStateDescription {
  white-space: pre-line;
  text-align: center;
  font-size: 15px;
  margin-bottom: 24px;
}

.imagesEmptyContainer {
  padding-top: 74px;
}

.smartImageEmptyContainer {
  padding: 0;
  min-height: 0;
}

.brandAnimationsEmptyContainer {
  position: relative;
  padding-top: 20px;
}

.designsPlaceholder {
  min-height: 1000px;
}

@media (max-width: 640px) {
  .masonryWrapper {
    width: 100%;
    margin: 16px auto auto auto;
    padding: 0;
    box-sizing: border-box;
    overflow: hidden;
  }

  .grid {
    margin: 0 auto;
  }

  /* Override Masonry library's inline gutter calculation for mobile */
  .gutterSizer {
    width: 12px !important;
  }

  .landscapeGutterSizer {
    width: 12px !important;
  }

  .item,
  .itemLandscape {
    margin-bottom: 12px;
    max-width: 100%;
  }

  .emptyStateContainer {
    padding-top: 80px;
    padding-bottom: 80px;
  }
}
